import { IFeatureProperties } from '../../../types/map';

// Подсвечен ли пин: общий визуальный признак для всех причин наведения/выбора (клик, карточка списка, курсор на пине)
export function getIsHighlighted({ isActive, isHovered }: IFeatureProperties): boolean {
  return Boolean(isActive || isHovered);
}
